import type { FreightMatching, TrackManager } from "@x-mile/api-contract";

export const VEHICLE_SHAPES_LIST: {
  value: NonNullable<FreightMatching.schemas.MasterDataVehicleShape>;
  textValue: NonNullable<TrackManager.schemas.MemberVehicleShapeText>;
  label: string;
}[] = [
  { value: "other", textValue: "指定なし", label: "指定なし" },
  { value: "flat", textValue: "平ボディ", label: "平ボディ" },
  { value: "box", textValue: "箱車", label: "箱車" },
  { value: "hood", textValue: "幌車", label: "幌車" },
  { value: "dump", textValue: "ダンプ", label: "ダンプ" },
  {
    value: "semi_trailer",
    textValue: "セミトレーラー",
    label: "セミトレーラー",
  },
  {
    value: "full_trailer",
    textValue: "フルトレーラー",
    label: "フルトレーラー",
  },
  { value: "refrigerator", textValue: "冷蔵冷凍車", label: "冷蔵冷凍車" },
];
export const isVehicleShape = (
  value: string | null | undefined,
): value is NonNullable<TrackManager.schemas.MemberVehicleShapeText> =>
  VEHICLE_SHAPES_LIST.some((shape) => shape.value === value);

export const VEHICLE_EQIUIPMENTS: {
  id: number;
  value: NonNullable<FreightMatching.schemas.MasterDataVehicleEquipmentsItem>;
  label: string;
}[] = [
  // FIXME: ロジポケではidとlabelのリストが取得できる/optionsというAPIを使用しているが
  // FIXME: そのようにしない(文字列enumでやりとりする)方針になったので ロジポケ側 POST /vehiclesと噛み合っていない
  // FIXME: 一旦idを決めうちで管理する。
  { id: 1, value: "air_suspension", label: "エアサス" },
  { id: 2, value: "roller", label: "ローラー" },
  { id: 3, value: "unic", label: "ユニック" },
  { id: 4, value: "food", label: "幌" },
  { id: 5, value: "wing", label: "ウィング" },
  { id: 6, value: "power_gate", label: "パワーゲート" },
];
